"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeEmailSignature = exports.SIGNATURE_CLASSLIST = exports.GMAIL_SIGNATURE = void 0;

var _SanitizeConfiguration = require("../sanitizers/SanitizeConfiguration");

var GMAIL_SIGNATURE = 'gmail_signature';
exports.GMAIL_SIGNATURE = GMAIL_SIGNATURE;
var HS_SIGNATURE = 'hs_signature'; // gmail class is covered separately

var SIGNATURE_CLASSLIST = [// HubSpot
HS_SIGNATURE];
exports.SIGNATURE_CLASSLIST = SIGNATURE_CLASSLIST;

var hasSignatureClass = function hasSignatureClass(classList) {
  return classList && classList.contains && SIGNATURE_CLASSLIST.some(function (className) {
    return classList.contains(className);
  });
};
/**
 * Users can insert content into the gmail_signature div, in situations where
 * all the content is in that div (i.e. no siblings) we should display the signature
 */


var isGmailSignatureAndHasSibling = function isGmailSignatureAndHasSibling(node) {
  return node.classList && node.classList.contains && node.classList.contains(GMAIL_SIGNATURE) && (node.nextElementSibling || node.previousElementSibling);
};

var removeEmailSignature = function removeEmailSignature(_ref) {
  var node = _ref.node;
  var classList = node.classList;
  var shouldRemoveSignature = isGmailSignatureAndHasSibling(node) || hasSignatureClass(classList);

  if (shouldRemoveSignature) {
    var span = _SanitizeConfiguration.secureDocument.createElement('span');

    span.innerHTML = '';
    return {
      node: span
    };
  }

  return null;
};

exports.removeEmailSignature = removeEmailSignature;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/transformers/removeEmailSignature.js
// module id = 817
// module chunks = 209 210 211 212